import homeHCImage from "../assets/homeHC.jpg";

const tips = [
  {
    id: 1,
    title: "How To Choose The Right Wheelchair",
    category: "Mobility",
    description:
      "Important things to consider when selecting a wheelchair for comfort and independence.",
    image: homeHCImage,
    bg: "bg-emerald-900",
    content: `
     Choosing the right wheelchair depends on the user's lifestyle, mobility needs, and comfort.
     1. User comfort
        A wheelchair should provide proper seating support, good posture, and enough comfort for daily use. Consider features like cushion quality, back support, and adjustable footrests.
     2. Mobility needs
        Think about where the wheelchair will be used. Indoor users may need a compact and lightweight chair, while outdoor users may require stronger wheels and durable construction. `,
  },
  {
    id: 2,
    title: "Choosing The Right Hospital Bed",
    category: "Patient Care",
    description:
      "Understand different hospital bed features and what works best for patient needs.",
    image: homeHCImage,
    bg: "bg-emerald-700",
    content: ` Selecting the right hospital bed improves patient comfort, safety, and recovery.
    1. Patient requirements
       Consider the patient's condition, mobility level, and the type of care required before choosing a bed.
    2. Adjustable features
       Modern hospital beds provide adjustable height, backrest, and leg positions to improve comfort and make caregiving easier. `,
  },
  {
    id: 3,
    title: "Home Healthcare Equipment Guide",
    category: "Home Care",
    description:
      "Learn how healthcare equipment can improve comfort and safety at home.",
    image: homeHCImage,
    bg: "bg-emerald-900",
    content: ` Home healthcare equipment helps patients receive quality care while staying in a familiar environment.
    1. Identify the patient's needs
       Different conditions require different equipment, such as mobility aids, patient beds, or monitoring devices.
    2. Focus on safety
       Equipment should reduce risks at home and make daily activities easier for both patients and caregivers. `,
  },
  {
    id: 4,
    title: "Mobility Support For Seniors",
    category: "Mobility",
    description:
      "Helpful advice for improving movement and independence.",
    image: homeHCImage,
    bg: "bg-emerald-700",
    content: ` Home healthcare equipment helps patients receive quality care while staying in a familiar environment.
    1. Identify the patient's needs
       Different conditions require different equipment, such as mobility aids, patient beds, or monitoring devices.
    2. Focus on safety
       Equipment should reduce risks at home and make daily activities easier for both patients and caregivers. `,
  },

  {
    id: 5,
    title: "Patient Safety At Home",
    category: "Safety",
    description:
      "Simple ways to create a safer environment for patients.",
    image: homeHCImage,
    bg: "bg-emerald-900",
    content: ` Home healthcare equipment helps patients receive quality care while staying in a familiar environment.
    1. Identify the patient's needs
       Different conditions require different equipment, such as mobility aids, patient beds, or monitoring devices.
    2. Focus on safety
       Equipment should reduce risks at home and make daily activities easier for both patients and caregivers. `,
  },

  {
    id: 6,
    title: "Medical Equipment Maintenance",
    category: "Equipment Guide",
    description:
      "Tips for keeping healthcare equipment working safely.",
    image: homeHCImage,
    bg: "bg-green-700",
    content: ` Home healthcare equipment helps patients receive quality care while staying in a familiar environment.
    1. Identify the patient's needs
       Different conditions require different equipment, such as mobility aids, patient beds, or monitoring devices.
    2. Focus on safety
       Equipment should reduce risks at home and make daily activities easier for both patients and caregivers. `,
  },
];

export default tips;